<template>
  <div class="reviews-carousel-container">
    <div
      class="elfsight-app-939bb468-30d8-40cf-8728-3af9495b3118"
      data-elfsight-app-lazy
    ></div>
  </div>
</template>

<script>
export default {
  name: "GoogleCarousel",
  mounted() {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>

<style scoped>
.reviews-carousel-container {
  padding: 2rem 1rem;

  color: white;
  text-align: center;
}
.reviews-title {
  color: yellow;
  font-size: 1.8rem;
  margin-bottom: 1rem;
}
</style>
